// BookingFlow

import { computeDuration, extractZipCodeFromGeosuggest } from "../helpers/bookingFlowHelpers"
import { simpleFetch } from "./acCommon"
import * as residencesActions from './acResidences'
import { normalizeResidence } from "../normalizers/residenceNormalizer"
import moment from "moment"
import { history } from "../history"

import { ACCOUNT_PROFILE, ACCOUNT_PROFILE_SUCCESS } from './acAccountProfile'

export const BOOKINGFLOW_UICHANGE = 'BOOKINGFLOW_UICHANGE'
export const bookingFlowUIChange = changes => ({ type: BOOKINGFLOW_UICHANGE, changes })
export const BOOKINGFLOW_METACHANGE = 'BOOKINGFLOW_METACHANGE'
export const bookingFlowMetaChange = changes => ({ type: BOOKINGFLOW_METACHANGE, changes })
export const BOOKINGFLOW_DATACHANGE = 'BOOKINGFLOW_DATACHANGE'
export const bookingFlowDataChange = changes => (dispatch, getState) => {
	dispatch({ type: BOOKINGFLOW_DATACHANGE, changes })
}

export const BookingFlowStep = Object.freeze({
	WELCOME: 'WELCOME',
	NEEDS: 'NEEDS',
	AVAILABILITIES: 'AVAILABILITIES',
	INFORMATIONS_SIGN_UP_IN: 'INFORMATIONS_SIGN_UP_IN',
	INFORMATIONS_RESIDENCE: 'INFORMATIONS_RESIDENCE',
	INFORMATIONS_SODEXO: 'INFORMATIONS_SODEXO',
	CONFIRMATION: 'CONFIRMATION'
})

export const BOOKINGFLOW_START = 'BOOKINGFLOW_START'
export const startBookingFlow = () => ({ type: BOOKINGFLOW_START })

export const handleUrlParameters = (query) => (dispatch, getState) => {
	let { zip_code: zipCode, language_reference: workerLanguageReference, affiliate_id: affiliateId, worker_id: workerId, worker_sodexo_reference: workerSodexoReference } = query
	if (zipCode) {
		dispatch(bookingFlowCheckZipCode(zipCode))
			.then(({ actionType, response, requestMeta }) => {
				if (actionType === BOOKING_FLOW_CHECK_ZIP_CODE_SUCCESS && response.covered) {
					if (workerSodexoReference) {
						dispatch(bookingFlowDataChange({ workerSodexoNumber: workerSodexoReference }))
					}

					dispatch(bookingFlowMetaChange({
						options: {
							workerLanguageReference: workerLanguageReference,
							affiliateID: affiliateId,
							workerId: workerId
						}
					}))
				}
			})
	}
}

export const BOOKING_FLOW_FIND_AFFILIATE = 'BOOKING_FLOW_FIND_AFFILIATE'
export const BOOKING_FLOW_FIND_AFFILIATE_REQUEST = 'BOOKING_FLOW_FIND_AFFILIATE_REQUEST'
export const BOOKING_FLOW_FIND_AFFILIATE_SUCCESS = 'BOOKING_FLOW_FIND_AFFILIATE_SUCCESS'
export const BOOKING_FLOW_FIND_AFFILIATE_FAILURE = 'BOOKING_FLOW_FIND_AFFILIATE_FAILURE'
export const loadPrefilledAffiliate = () => (dispatch, getState) => {
	let { bookingFlow } = getState().metadataReducer

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_find_affiliate',
	}

	dispatch(simpleFetch('/customers/affiliates/' + bookingFlow.options.affiliateID, {
		method: 'GET',
	}, BOOKING_FLOW_FIND_AFFILIATE, requestMeta))
}

// Address selection
export const addressSuggestionSelected = (suggestion) => (dispatch, getState) => {
	let changes = { selectedAddressSuggestion: suggestion }
	changes.isStepWelcomeValid = true
	dispatch(bookingFlowMetaChange(changes))
	dispatch(bookingFlowDataChange(changes))
}

export const bookingFlowValidateStepWelcome = (affiliateId) => (dispatch, getState) => {
	let { bookingFlow } = getState().dataReducer
	if (bookingFlow.selectedAddressSuggestion !== undefined) {
		let zipCode = extractZipCodeFromGeosuggest(bookingFlow.selectedAddressSuggestion)
		if (zipCode !== undefined) {
			dispatch(bookingFlowCheckZipCode(zipCode, affiliateId))
		}
	}
}

export const BOOKING_FLOW_CHECK_ZIP_CODE = 'BOOKING_FLOW_CHECK_ZIP_CODE'
export const BOOKING_FLOW_CHECK_ZIP_CODE_REQUEST = 'BOOKING_FLOW_CHECK_ZIP_CODE_REQUEST'
export const BOOKING_FLOW_CHECK_ZIP_CODE_SUCCESS = 'BOOKING_FLOW_CHECK_ZIP_CODE_SUCCESS'
export const BOOKING_FLOW_CHECK_ZIP_CODE_FAILURE = 'BOOKING_FLOW_CHECK_ZIP_CODE_FAILURE'
export const bookingFlowCheckZipCode = (zipCode, affiliateId) => (dispatch, getState) => {
	let params = {
		zip_code: parseInt(zipCode, 10)
	}

	if (affiliateId) {
		params.affiliate_id = affiliateId
	}

	let body = JSON.stringify(params)

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_checking_zip_code',
		zipCode: zipCode
	}

	return dispatch(simpleFetch('/public/check_zip_code', {
		method: 'POST',
		body: body
	}, BOOKING_FLOW_CHECK_ZIP_CODE, requestMeta))
		.then(({ actionType, response, requestMeta }) => {
			if (actionType === BOOKING_FLOW_CHECK_ZIP_CODE_SUCCESS && response.covered) {
				bookingFlowNeedsFetchData(dispatch, getState)
				history.push("/booking-flow") // needed for affiliate-page
			}
			else if (!response.covered) {
				dispatch(this.bookingFlowMetaChange({ enterZipCodeNotCovered: true }))
			}

			return { actionType, response, requestMeta }
		})
}

export const ASK_FOR_ZIP_CODE = 'ASK_FOR_ZIP_CODE'
export const ASK_FOR_ZIP_CODE_REQUEST = 'ASK_FOR_ZIP_CODE_REQUEST'
export const ASK_FOR_ZIP_CODE_SUCCESS = 'ASK_FOR_ZIP_CODE_SUCCESS'
export const ASK_FOR_ZIP_CODE_FAILURE = 'ASK_FOR_ZIP_CODE_FAILURE'
export const askForZipCode = () => (dispatch, getState) => {

	let { bookingFlow } = getState().dataReducer
	let email = getState().metadataReducer.bookingFlow.emailZipCodeNotCovered

	if (bookingFlow.selectedAddressSuggestion !== undefined) {
		let zipCode = extractZipCodeFromGeosuggest(bookingFlow.selectedAddressSuggestion)

		let body = JSON.stringify({
			zip_code: parseInt(zipCode, 10),
			email: email
		})

		let requestMeta = {
			spinnerMessageKey: 'spinner_message_ask_for_zip_code',
			zipCode: zipCode
		}

		dispatch(simpleFetch('/public/ask_for_zip_code', {
			method: 'POST',
			body: body
		}, ASK_FOR_ZIP_CODE, requestMeta))
			.then(({ actionType, response, requestMeta }) => {
				dispatch(this.bookingFlowMetaChange({ enterZipCodeNotCovered: false, showZipCodeNotCovered: false }))
			})
	}
}

// Needs
export const bookingFlowNeedsFetchData = (dispatch, getState) => {
	bookingFlowFetchWorkerLanguages(dispatch, getState)
	bookingFlowFetchAffiliates(dispatch, getState)

	let isSignedId = getState().metadataReducer.auth.signedIn
	if (isSignedId) {
		bookingFlowFetchWorkers(dispatch, getState)
	}
}

export const BOOKING_FLOW_FETCH_WORKER_LANGUAGES = 'BOOKING_FLOW_FETCH_WORKER_LANGUAGES'
export const BOOKING_FLOW_FETCH_WORKER_LANGUAGES_REQUEST = 'BOOKING_FLOW_FETCH_WORKER_LANGUAGES_REQUEST'
export const BOOKING_FLOW_FETCH_WORKER_LANGUAGES_SUCCESS = 'BOOKING_FLOW_FETCH_WORKER_LANGUAGES_SUCCESS'
export const BOOKING_FLOW_FETCH_WORKER_LANGUAGES_FAILURE = 'BOOKING_FLOW_FETCH_WORKER_LANGUAGES_FAILURE'
const bookingFlowFetchWorkerLanguages = (dispatch, getState) => {
	let requestMeta = {
		spinnerMessageKey: 'spinner_message_fetching_worker_languages',
	}

	dispatch(simpleFetch('/customers/worker_languages', {
		method: 'GET'
	}, BOOKING_FLOW_FETCH_WORKER_LANGUAGES, requestMeta))
		.then(({ actionType, response, requestMeta }) => {
			let { workerLanguageReference } = getState().metadataReducer.bookingFlow.options
			if (actionType === BOOKING_FLOW_FETCH_WORKER_LANGUAGES_SUCCESS && workerLanguageReference) {
				for (let i = 0; i < response.data.length; i++) {
					let workerLanguage = response.data[i]
					if (workerLanguage.attributes.reference === workerLanguageReference) {
						dispatch(bookingFlowDataChange({ selectedWorkerLanguage: workerLanguage }))
						break
					}
				}
			}
		})
}

export const BOOKING_FLOW_FETCH_AFFILIATES = 'BOOKING_FLOW_FETCH_AFFILIATES'
export const BOOKING_FLOW_FETCH_AFFILIATES_REQUEST = 'BOOKING_FLOW_FETCH_AFFILIATES_REQUEST'
export const BOOKING_FLOW_FETCH_AFFILIATES_SUCCESS = 'BOOKING_FLOW_FETCH_AFFILIATES_SUCCESS'
export const BOOKING_FLOW_FETCH_AFFILIATES_FAILURE = 'BOOKING_FLOW_FETCH_AFFILIATES_FAILURE'
const bookingFlowFetchAffiliates = (dispatch, getState) => {
	let { bookingFlow } = getState().dataReducer

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_fetching_affiliates',
	}

	dispatch(simpleFetch('/customers/affiliates?zip_code=' + bookingFlow.zipCode, {
		method: 'GET'
	}, BOOKING_FLOW_FETCH_AFFILIATES, requestMeta))
		.then(({ actionType, response, requestMeta }) => {
			let { affiliateID } = getState().metadataReducer.bookingFlow.options
			if (actionType === BOOKING_FLOW_FETCH_AFFILIATES_SUCCESS && affiliateID) {
				for (let i = 0; i < response.data.length; i++) {
					let affiliate = response.data[i]
					if (affiliate.id === affiliateID) {
						dispatch(bookingFlowDataChange({ selectedAffiliate: affiliate }))
						break
					}
				}
			}
		})
}

export const BOOKING_FLOW_FETCH_WORKERS = 'BOOKING_FLOW_FETCH_WORKERS'
export const BOOKING_FLOW_FETCH_WORKERS_REQUEST = 'BOOKING_FLOW_FETCH_WORKERS_REQUEST'
export const BOOKING_FLOW_FETCH_WORKERS_SUCCESS = 'BOOKING_FLOW_FETCH_WORKERS_SUCCESS'
export const BOOKING_FLOW_FETCH_WORKERS_FAILURE = 'BOOKING_FLOW_FETCH_WORKERS_FAILURE'
const bookingFlowFetchWorkers = (dispatch, getState) => {
	let requestMeta = {
		spinnerMessageKey: 'spinner_message_fetching_worker_contracts',
	}

	dispatch(simpleFetch('/customers/worker_contracts', {
		method: 'GET'
	}, BOOKING_FLOW_FETCH_WORKERS, requestMeta))
		.then(({ actionType, response, requestMeta }) => {
			let { workerId } = getState().metadataReducer.bookingFlow.options
			if (actionType === BOOKING_FLOW_FETCH_WORKERS_SUCCESS && workerId) {
				for (let i = 0; i < response.data.length; i++) {
					let worker = response.data[i]
					if (worker.id === workerId) {
						dispatch(bookingFlowDataChange({ selectedWorker: worker }))
						break
					}
				}
			}
		})
}


export const BOOKING_FLOW_TOGGLE_BOOKING_SERVICE = 'BOOKING_FLOW_TOGGLE_BOOKING_SERVICE'
export const bookingFlowToggleBookingService = (bookingServiceId) => (dispatch, getState) => {
	dispatch({ type: BOOKING_FLOW_TOGGLE_BOOKING_SERVICE, bookingServiceId })
}

export const BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER = 'BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER'
export const BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_REQUEST = 'BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_REQUEST'
export const BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_SUCCESS = 'BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_SUCCESS'
export const BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_FAILURE = 'BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_FAILURE'
export const bookingFlowValidateStepNeeds = (bedroomsCount, bathroomsCount) => (dispatch, getState) => {
	let { bookingFlow } = getState().dataReducer

	if (bookingFlow.workerSodexoNumber !== undefined && bookingFlow.workerSodexoNumber !== '') {
		let requestMeta = {
			spinnerMessageKey: 'spinner_message_checking_worker_sodexo_number',
		}

		dispatch(simpleFetch('/customers/check_cleaner_sodexo_reference?sodexo_reference=' + bookingFlow.workerSodexoNumber, {
			method: 'GET'
		}, BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER, requestMeta))
			.then(({ actionType, response, requestMeta }) => {
				if (actionType === BOOKING_FLOW_CHECK_WORKER_SODEXO_NUMBER_SUCCESS && response.sodexo_reference_exists) {
					goToStepAvailabilities(dispatch, getState, bedroomsCount, bathroomsCount)
				}
			})
	} else {
		goToStepAvailabilities(dispatch, getState, bedroomsCount, bathroomsCount)
	}
}

const goToStepAvailabilities = (dispatch, getState) => {
	updateDuration(dispatch, getState)
	findFirstAvailableTimeSlotsWeek(dispatch, moment().startOf('isoWeek'), 0)
	dispatch(bookingFlowMetaChange({ currentStep: BookingFlowStep.AVAILABILITIES }))
}

export const updateDuration = (duration) => (dispatch, getState) => {
	let newDuration = duration
	if (duration === undefined) {
		let bookingFlow = getState().dataReducer.bookingFlow
		let bookingServicesCount = bookingFlow.bookingServices.length
		newDuration = computeDuration((bookingFlow.bedroomsCount + bookingFlow.bathroomsCount), bookingServicesCount)
	}
	dispatch(bookingFlowDataChange({ duration: newDuration }))
}

const findFirstAvailableTimeSlotsWeek = (dispatch, currentWeek, attempts) => {
	dispatch(bookingFlowFetchTimeSlots(currentWeek))
		.then(({ actionType, response, requestMeta }) => {
			if (actionType === BOOKING_FLOW_FETCH_TIME_SLOTS_SUCCESS && response.data.length > 0 && hasTimeSlots(response)) {
				dispatch(bookingFlowMetaChange({ currentTimeSlotWeek: currentWeek }))
			} else if (attempts < 5) {
				let newWeek = currentWeek.add(1, 'weeks')
				dispatch(bookingFlowMetaChange({ currentTimeSlotWeek: newWeek }))
				findFirstAvailableTimeSlotsWeek(dispatch, newWeek, ++attempts)
			} else {
				dispatch(this.bookingFlowMetaChange({enterZipCodeNotCovered: true}))
			}
		})
}

const hasTimeSlots = (response) => {
	let hasTimeSlots = false

	response.data.forEach((dayTimeSlots) => {
		if (dayTimeSlots.time_slots.length > 0) {
			hasTimeSlots = true
			return true
		}
	})

	return hasTimeSlots
}


// Date selection
export const BOOKING_FLOW_FETCH_TIME_SLOTS = 'BOOKING_FLOW_FETCH_TIME_SLOTS'
export const BOOKING_FLOW_FETCH_TIME_SLOTS_REQUEST = 'BOOKING_FLOW_FETCH_TIME_SLOTS_REQUEST'
export const BOOKING_FLOW_FETCH_TIME_SLOTS_SUCCESS = 'BOOKING_FLOW_FETCH_TIME_SLOTS_SUCCESS'
export const BOOKING_FLOW_FETCH_TIME_SLOTS_FAILURE = 'BOOKING_FLOW_FETCH_TIME_SLOTS_FAILURE'
export const bookingFlowFetchTimeSlots = (week) => (dispatch, getState) => {
	let { zipCode, duration, frequency, selectedWorkerLanguage, selectedWorker, workerSodexoNumber, selectedAffiliate } = getState().dataReducer.bookingFlow

	let url = '/customers/search_premium_time_slots?zip_code=' + zipCode + '&duration_in_hours=' + duration + '&recurrence_type=' + frequency + '&delivery_date=' + week.format('YYYY-MM-DD')

	if (selectedWorkerLanguage) {
		url += '&language_id=' + selectedWorkerLanguage.attributes.reference
	}

	if (selectedWorker) {
		url += '&worker_sodexo_reference=' + selectedWorker.attributes.sodexo_reference
	} else if (workerSodexoNumber) {
		url += '&worker_sodexo_reference=' + workerSodexoNumber
	}

	if (selectedAffiliate) {
		url += '&affiliate_id=' + selectedAffiliate.id
	}

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_fetching_time_slots',
	}

	return dispatch(simpleFetch(url, {
		method: 'GET'
	}, BOOKING_FLOW_FETCH_TIME_SLOTS, requestMeta))
}

export const bookingFlowValidateStepAvailabilities = () => (dispatch, getState) => {
	let isSignedId = getState().metadataReducer.auth.signedIn
	if (isSignedId) {
		dispatch(residencesActions.fetchResidences())
	}
	dispatch(bookingFlowMetaChange({ currentStep: isSignedId ? BookingFlowStep.INFORMATIONS_RESIDENCE : BookingFlowStep.INFORMATIONS_SIGN_UP_IN }))
}

export const bookingFlowSelectResidence = (residence) => (dispatch, getState) => {
	dispatch(bookingFlowDataChange({ selectedResidence: residence, selectedSodexoResidence: residence }))
	dispatch(bookingFlowMetaChange({ currentStep: BookingFlowStep.INFORMATIONS_SODEXO }))
}

export const bookingFlowValidateResidenceSelectionStep = () => (dispatch, getState) => {
	dispatch(residencesActions.createResidence())
		.then(({ actionType, response, requestMeta }) => {
			if (actionType === residencesActions.CREATE_RESIDENCE_SUCCESS) {
				let residence = normalizeResidence(response.data)
				dispatch(bookingFlowDataChange({ selectedResidence: residence, selectedSodexoResidence: residence }))
				dispatch(bookingFlowMetaChange({ currentStep: BookingFlowStep.INFORMATIONS_SODEXO }))
			}
		})
}

export const SODEXO_REGISTRATION = 'SODEXO_REGISTRATION'
export const SODEXO_REGISTRATION_REQUEST = 'SODEXO_REGISTRATION_REQUEST'
export const SODEXO_REGISTRATION_SUCCESS = 'SODEXO_REGISTRATION_SUCCESS'
export const SODEXO_REGISTRATION_FAILURE = 'SODEXO_REGISTRATION_FAILURE'
export const bookingFlowValidateSodexoStep = () => (dispatch, getState) => {
	let {
		metadataReducer: { bookingFlow: { alreadyRegisterToSodexo } },
		dataReducer: { bookingFlow: { voucherType, sodexoRegion, sodexoNumber, niss, selectedSodexoResidence, iban } }
	} = getState()

	if (!alreadyRegisterToSodexo) {
		let address = selectedSodexoResidence.address

		let body = JSON.stringify({
			iban: 'BE' + iban,
			zip_code: address.zipCode,
			street_name: address.streetName,
			street_number: address.streetNumber,
			sodexo_region: sodexoRegion,
			voucher_type: voucherType,
			niss: niss
		})

		let requestMeta = {
			spinnerMessageKey: 'spinner_message_sodexo_registration',
		}

		dispatch(simpleFetch('/customers/register_sodexo', {
			method: 'POST',
			body: body
		}, SODEXO_REGISTRATION, requestMeta))
	} else {

		let body = JSON.stringify({
			sodexo_region: sodexoRegion,
			sodexo_reference: sodexoNumber
		})

		let requestMeta = {
			spinnerMessageKey: 'spinner_message_account_profile',
		}

		dispatch(simpleFetch('/customers/profile/', {
			method: 'PUT',
			body: body
		}, ACCOUNT_PROFILE, requestMeta)).then(({ actionType, response, requestMeta }) => {
			if (actionType === ACCOUNT_PROFILE_SUCCESS) {
				dispatch(bookingFlowMetaChange({ currentStep: BookingFlowStep.CONFIRMATION }))
			}
		})


	}
}

export const BOOKING_FLOW_CREATE_BOOKING = 'BOOKING_FLOW_CREATE_BOOKING'
export const BOOKING_FLOW_CREATE_BOOKING_REQUEST = 'BOOKING_FLOW_CREATE_BOOKING_REQUEST'
export const BOOKING_FLOW_CREATE_BOOKING_SUCCESS = 'BOOKING_FLOW_CREATE_BOOKING_SUCCESS'
export const BOOKING_FLOW_CREATE_BOOKING_FAILURE = 'BOOKING_FLOW_CREATE_BOOKING_FAILURE'
export const bookingFlowValidateConfirmationStep = () => (dispatch, getState) => {
	let {
		dataReducer: { bookingFlow: { zipCode, duration, selectedTimeSlot, frequency, selectedResidence, voucherType, selectedWorkerLanguage } }
	} = getState()
	let worker = selectedTimeSlot.worker
	let startTime = moment(selectedTimeSlot.startTime)
	let endTime = moment(selectedTimeSlot.endTime)

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_create_booking',
	}

	let body = JSON.stringify({
		zip_code: zipCode,
		duration_in_hours: duration.toString(),
		worker_contract_id: worker.id,
		affiliate_id: worker.affiliateId,
		recurrence: frequency !== 0,
		recurrence_delay: frequency.toString(),
		delivery_date: startTime.format('YYYY-MM-DDT00:00:00Z'),
		start_time: startTime.format(),
		end_time: endTime.format(),
		residence_id: selectedResidence.id,
		voucher_type: voucherType,
		language_id: selectedWorkerLanguage ? selectedWorkerLanguage.id : ''
	})

	dispatch(simpleFetch('/customers/bookings', {
		method: 'POST',
		body: body
	}, BOOKING_FLOW_CREATE_BOOKING, requestMeta))
		.then(({ actionType, response, requestMeta }) => {
			if (actionType === BOOKING_FLOW_CREATE_BOOKING_SUCCESS) {
				history.push('/app')
				dispatch(startBookingFlow())
			}
		})
}


// WEBPACK FOOTER //
// ./src/actions/acBookingFlow.js